
enum ComfortLevel {
  Never = 'Never',
  Learning = 'Learning',
  Reguarly = 'Regularly',
  CantDo = 'CantDo',
}

const comfortQuestion = {
  name: 'comfort',
  title: 'How comfortable are you with the squat, bench and deadlift?',
  description: 'This gives us a clearer picture of your daily routine.',
  type: 'radiogroup',
  choices: [
    {
      value: ComfortLevel.Never,
      text: "<div class='icon-button'><div>😬</div><div>Never done them<br /><span class=\"small-text\">They seem intimidating or unfamiliar</span></div></div>",
    },
    {
      value: ComfortLevel.Learning,
      text: "<div class='icon-button'><div>🧑‍🔬</div><div>Still learning<br /><span class=\"small-text\">I’ve tried them but I’m working on my form</span></div></div>",
    },
    {
      value: ComfortLevel.Reguarly,
      text: "<div class='icon-button'><div>✅</div><div>Confident and consistent<br /><span class=\"small-text\">I do them regularly with good technique</span></div></div>",
    },
    {
      value: ComfortLevel.CantDo,
      text: "<div class='icon-button'><div>🛑</div><div>Not an option for me<br /><span class=\"small-text\">I avoid them due to injury or physical limitations</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  ComfortLevel,
  comfortQuestion,
}